<template>
  <div id="AffiliateList">
    <div class="text-center" v-if="loading == 1">
      <i class="fas fa-spinner fa-spin fa-2x theme-color"></i>
    </div>
    
    <div class="row" v-else-if="!link">
      <div class="col text-left">
        <h4 class="mb-4">Afiliados</h4>
        <p>
          Para participar do programa de afiliados Uli Site ou outras empresas e
          ganhar dinheiro com indicações, entre em contato:
        </p>
        <p>
          (17) <b>3223 5208</b>
          <br />
          contato@ulisite.com
        </p>
      </div>
    </div>

    <div class="row" v-else>
      <div class="col text-left pt-3" v-if="cupom.reward > 1">
        <p class="title--affiliate">
          Ganhe R$ {{ normalizeVaule(cupom.reward) }} por cada site indicado ativo!
        </p>
      </div>

      <div class="col-12 my-6">
        <div class="row">
          <div class="col-6">
            <p class="label--link">Saldo disponível</p>
            <p>
              <strong>R$ {{ totalValue }}</strong>
            </p>
                
            <button v-if="totalValue != '0'  && rescue == 0" class="btn btn-primario" @click="rescueReward()">Resgatar</button>
          </div>

          <div class="col-6">
            <!--<p class="label--link">Saldo a liberar</p>
            <p>
              R$ {{ totalValue }}
            </p>-->

            <p class="label--link">Ganho total</p>
            <p>
              R$ {{ totalGain }}
            </p>
          </div>

          <div class="col-12">
            <p class="label--link">Indique pelo link</p>
            <p class="link--affiliate" id="user-link">
              <a :href="link" target="_blank" rel="noopener noreferrer"><strong>{{link}}</strong></a>
            </p>
            <p v-if="copySucceeded">
              <span>
                <small>{{ copySucceeded }}</small>
              </span>
            </p>
          </div>

          <div class="col-12 mt-3" v-if="allAffiliates.length > 0">
            <p class="label--link">Suas indicações</p>
            <div class="row mb-3">
              <div class="col-6 text-left">
                <strong>{{filterAffiliates.length}}</strong> indicados
              </div>

              <div class="col-6 text-right">
                <select class="bg-white" v-model="activeFilter">
                  <option value="all">Todos</option>
                  <option value="pending">Pendentes</option>
                  <option value="active">Ativos</option>
                  <option value="canceled">Cancelados</option>
                </select>
              </div>
            </div>
            
            <div v-for="(affiliate, index) in filterAffiliates" :key="index">
              <AffiliateCard
                :site="affiliate"
                :plans="plans"
                :vendor="vendor"
                :code="code"
                @reload="reload"
                class="my-3"
              />
            </div>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import AffiliateCard from "@/components/organisms/AffiliateCard";
export default {
  name: "AffiliateList",
  data() {
    return {
      showCopyAlert: false,
      copySucceeded: "",
      link: null,
      allAffiliates: [],
      filterAffiliates: [],
      activeFilter: 'all',
      totalValue: 0,
      totalGain: 0,
      cupom: {},
      rescue: 0,
      rescueMessage: "",
      loading: 1,
      vendor: false,
      plans: [],
      code: null,
      api: null
    };
  },
  components: {
    AffiliateCard
  },
  watch: {
    activeFilter() {
      if(this.activeFilter != 'all'){
        this.filterAffiliates = this.allAffiliates.filter((item) => item.status == this.activeFilter)
      }
      else{
        this.filterAffiliates = this.allAffiliates;
      }
    },
  },
  methods: {
    reload(){
      this.getAffiliates();
    },
    receiveReward() {
      this.$router.push("/dashboard/receive");
    },
    rescueReward() {
      let token = this.$session.get("jwt");
      axios({
        method: "post",
        url: process.env.ROOT_API + "/api/code/reward/rescue",
        data: {},
        headers: {
          Authorization: "Bearer " + token
        }
      })
      .then(response => {
        if (response.data.status == "1") {
          this.rescue = 1;
        } else {
          this.rescue = 0;
          this.rescueMessage = response.data.message;
        }
      })
      .catch(response => {});
    },
    getAffiliates() {
      let token = this.$session.get("jwt");
      axios({
        method: "get",
        url: process.env.ROOT_API + "/api/user/code/list",
        data: "",
        headers: {
          Authorization: "Bearer " + token
          // 'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
        .then(response => {
          console.log(response);
          if (response.data.status == '1') {
            this.allAffiliates = response.data.data;
            this.filterAffiliates = response.data.data;
            this.totalValue = response.data.totalValue;
            this.totalGain = response.data.totalGain;
            this.plans = response.data.plans;
            this.vendor = response.data.level > 0;
            this.code = response.data.code;
          }
          this.loading = 0;
        })
        .catch(response => {});
    },
    normalizeVaule(value) {
      if (value) {
        value = value.replace(".", ",");
        return value;
      } else {
        return "0";
      }
    }
  },
  created() {
    this.link = this.$store.state.user.codes[0].url;
    this.copySucceeded = false;
  },
  mounted() {
    //this.api = 'http://localhost:8000';
    this.getAffiliates();
    this.cupom = this.$store.state.user.codes[0];
  },
  computed: {
    /*filterAffiliates() {
      return this.allAffiliates;
    },*/
    affiliateCounter() {
      let count = this.allAffiliates.length;
      if (count == 0) {
        return "0 indicados";
      } else if (count == 1) {
        return `${count} indicado`;
      } else {
        return `${count} indicados`;
      }
    }
  }
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
.copy-button {
  cursor: pointer;
  border-radius: 50%;
  color: #777;
  font-size: 1.2rem;
}
.copy-button:hover {
  color: var(--main-color);
}
.user-link {
  color: var(--main-color);
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  width: 100%;
  flex-wrap: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.total-ganhos,
.total-link {
  color: #777;
}
.item--collapse {
  padding: 25px 20px;
  cursor: pointer;
  border: 1px solid #cecece;
  border-left: none;
  border-right: none;
  text-align: left;
}
.item--collapse p {
  padding: 0 10px;
}
.item--collapse + .item--collapse {
  border-top: none;
}
.reward--label,
.label--link {
  font-size: 0.62rem;
  font-weight: 700;
  color: #cccccc;
  margin-bottom: 0;
}
.reward--balance,
.title--affiliate {
  font-size: 1.56rem;
  font-weight: 700;
  line-height: 1.87rem;
  color: #000000;
  margin-bottom: 0;
}
.link--affiliate a {
  color: var(--main-color);
  cursor: pointer;
  margin: 0;
}
.link--affiliate a:hover {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/AffiliateList.vue